(function() {
  'use strict';
  moduleConfig.registerModule('eclipseApp.linkAccount', ['eclipseApp.core', 'dtmService.module']);
}());
